"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/@react/index.ts
var react_exports = {};
__export(react_exports, {
  CAN_USE_DOM: () => CAN_USE_DOM,
  CSS_MAX_NUMBER: () => CSS_MAX_NUMBER,
  PREFERS_REDUCED_MOTION: () => PREFERS_REDUCED_MOTION,
  addEventListener: () => addEventListener,
  cell: () => cell,
  forwardRef: () => forwardRef,
  getBoundingClientRect: () => getBoundingClientRect,
  getNextElement: () => getNextElement,
  getReactNode: () => getReactNode,
  groupByPrefix: () => groupByPrefix,
  isolate: () => isolate,
  maybeCloneElement: () => maybeCloneElement,
  measureText: () => measureText,
  memo: () => memo,
  mutationObserver: () => mutationObserver,
  noSsr: () => noSsr,
  requestAnimationFrame: () => requestAnimationFrame,
  resizeObserver: () => resizeObserver,
  useBroadcastRef: () => useBroadcastRef,
  useControlledState: () => useControlledState,
  useDidMount: () => useDidMount,
  useEffect: () => useEffect3,
  useFontsReady: () => useFontsReady,
  useLayoutEffect: () => useLayoutEffect,
  useLiveCallback: () => useLiveCallback,
  useLiveRef: () => useLiveRef,
  useOnlyChildWithRef: () => useOnlyChildWithRef,
  wrap: () => wrap
});
module.exports = __toCommonJS(react_exports);

// src/@react/addEventListener.ts
var import_utils = require("@appd/utils");
var addEventListener = /* @__PURE__ */ __name((element, type, listener, { passive = true, ...options } = {}) => element ? (element.addEventListener(
  type,
  listener,
  {
    passive,
    ...options
  }
), () => element.removeEventListener(
  type,
  listener,
  // Only used to determine if `capture` phase.
  options
)) : import_utils.noop, "addEventListener");

// src/@react/CAN_USE_DOM.ts
var CAN_USE_DOM = Boolean(globalThis.document);

// src/@react/cell.ts
var import_utils2 = require("@appd/utils");
var cell = /* @__PURE__ */ __name((saved, input, nextOutput) => {
  const triviallyChanged = saved.input === void 0;
  const changes = Object.keys({
    ...saved.input,
    ...input
  }).map(
    (key) => triviallyChanged || !Object.is(input[key], saved.input?.[key]) ? [
      `\u0394${key}`,
      {
        new: input[key],
        old: saved.input?.[key]
      }
    ] : void 0
  );
  if (triviallyChanged || changes.some(import_utils2.Boolean)) {
    saved.output = nextOutput(input, Object.fromEntries(changes.filter(import_utils2.Boolean)));
    saved.input = input;
  }
  return saved.output;
}, "cell");
cell.init = (...[initial]) => ({ output: initial });
cell.initWithInput = (output, input = output && typeof output === "object" ? output : void 0) => ({
  input,
  output
});

// src/@react/CSS_MAX_NUMBER.ts
var CSS_MAX_NUMBER = Math.min(
  ...Object.values({
    CHROME: 16777200,
    FIREFOX: 340282e33,
    SAFARI: 33554428
  })
);

// src/@react/forwardRef.ts
var import_react = __toESM(require("react"));
var forwardRef = /* @__PURE__ */ __name((render) => (
  // @ts-expect-error
  // Type '{}' is not assignable to type '"ref" extends Exclude<keyof Props, "ref"> ? Pick<Omit<Props, "ref">, Exclude<Exclude<keyof Props, "ref">, Exclude<keyof Props, "ref"> & "ref">> : Omit<Props, "ref">'.ts(2322)
  Object.defineProperties(import_react.default.forwardRef(render), {
    // Hide private members from iteration.
    // https://github.com/facebook/react/blob/d5f1b067c8bbb826b823d0354a28ba31078b70c0/packages/react/src/ReactForwardRef.js#L47-L48
    ...{
      $$typeof: {
        configurable: true,
        enumerable: false,
        writable: false
      },
      render: {
        configurable: true,
        enumerable: false,
        // TMNT-4309 Support easier mocking.
        writable: true
      }
    },
    // These appear to be added by React at some point later. Eagerly mark as non-enumerable.
    ...{
      Props: {
        configurable: true,
        enumerable: false,
        writable: true
      },
      Static: {
        configurable: true,
        enumerable: false,
        writable: true
      }
    }
  })
), "forwardRef");

// src/@react/getBoundingClientRect.ts
var import_utils3 = require("@appd/utils");
var getBoundingClientRect = /* @__PURE__ */ __name((element) => {
  if (!element) {
    return void 0;
  }
  return {
    get bottom() {
      return element.getBoundingClientRect().bottom;
    },
    get height() {
      return element.getBoundingClientRect().height;
    },
    get left() {
      return element.getBoundingClientRect().left;
    },
    get right() {
      return element.getBoundingClientRect().right;
    },
    toJSON() {
      return import_utils3.IS_JEST ? JEST_ONLY.toJSON(element.getBoundingClientRect()) : element.getBoundingClientRect().toJSON();
    },
    get top() {
      return element.getBoundingClientRect().top;
    },
    get width() {
      return element.getBoundingClientRect().width;
    },
    get x() {
      return element.getBoundingClientRect().x;
    },
    get y() {
      return element.getBoundingClientRect().y;
    }
  };
}, "getBoundingClientRect");
getBoundingClientRect.ZEROS = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  toJSON: () => (0, import_utils3.omit)("toJSON").from(getBoundingClientRect.ZEROS),
  top: 0,
  width: 0,
  x: 0,
  y: 0
};
var JEST_ONLY;
((JEST_ONLY2) => {
  JEST_ONLY2.toJSON = /* @__PURE__ */ __name(({ bottom, height, left, right, top, width, x, y }) => ({
    bottom,
    height,
    left,
    right,
    top,
    width,
    x,
    y
  }), "toJSON");
})(JEST_ONLY || (JEST_ONLY = {}));

// src/@react/getNextElement.ts
var import_utils4 = require("@appd/utils");
var getNextElement = /* @__PURE__ */ __name((element, selector, {
  onlyIf = /* @__PURE__ */ __name(() => true, "onlyIf"),
  recurseUp = /* @__PURE__ */ __name(() => true, "recurseUp")
}) => {
  const parent = element.parentElement;
  if (!parent) {
    return null;
  }
  let index = Array.prototype.indexOf.call(parent.children, element);
  while (true) {
    const candidate = parent.querySelector(
      String([`:scope > :nth-child(n + ${index + 2})${selector}`, `:scope > :nth-child(n + ${index + 2}) ${selector}`])
    );
    if (candidate instanceof HTMLElement) {
      if (onlyIf(candidate)) {
        return candidate;
      }
      index = (0, import_utils4.findIndex)(parent.children, candidate);
    } else {
      return element.parentElement && recurseUp(element.parentElement) ? getNextElement(element.parentElement, selector, {
        onlyIf,
        recurseUp
      }) : null;
    }
  }
}, "getNextElement");
getNextElement.FOCUSABLE = `:where(${[
  "[contenteditable]",
  "[draggable='true']",
  "[tabindex]",
  "a[href]",
  "button",
  "details",
  "embed",
  "iframe",
  "input:not([type='hidden'])",
  "object",
  "select",
  "textarea"
]}):not(${[":disabled", "[disabled]", "[tabindex='-1']"]})`;
getNextElement.ONLY_IF_VISIBLE = (candidate) => (
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility
  // Property 'checkVisibility' does not exist on type 'HTMLElement'.ts(2339)
  // @ts-expect-error
  candidate.checkVisibility({
    contentVisibilityAuto: true,
    opacityProperty: true,
    visibilityProperty: true
  }) && !candidate.hasAttribute("hidden")
);

// src/@react/getReactNode.ts
var import_utils5 = require("@appd/utils");
var import_react2 = require("react");
var getReactNode = /* @__PURE__ */ __name((x, isTop = true) => typeof x === "number" || typeof x === "string" || typeof x === "boolean" || x == null || (0, import_react2.isValidElement)(x) ? (
  // Generics break inference
  x
) : import_utils5.Array.isArray(x) ? (isTop ? import_react2.Children.toArray : import_utils5.identity)(x.map((x2) => getReactNode(x2, false))) : (0, import_utils5.Do)(
  () => import_react2.Children.toArray(
    // Purposely trigger error to log as warning.
    x
  )
).catch((reason) => import_utils5.IS_DEV_MODE && console.warn(reason)).done(), "getReactNode");

// src/@react/groupByPrefix.ts
var import_utils6 = require("@appd/utils");
var groupByPrefix = /* @__PURE__ */ __name((properties, prefix) => (0, import_utils6.transform)(
  import_utils6.Object.groupBy(import_utils6.Object.entries(properties), ([key]) => key.startsWith(prefix) ? "prefixed" : "unprefixed")
).by.entry(
  ([kind, entries]) => entries && [
    kind,
    import_utils6.Object.fromEntries(
      kind === "prefixed" ? entries.map(([key, value]) => [key.slice(prefix.length), value]) : entries
    )
  ]
), "groupByPrefix");

// src/@react/isolate.ts
var isolate = /* @__PURE__ */ __name((event, {
  stopImmediatePropagation = true,
  stopPropagation = stopImmediatePropagation || true,
  preventDefault = true
} = {}) => {
  if (preventDefault) {
    event.preventDefault();
  }
  if (stopImmediatePropagation) {
    event.stopImmediatePropagation?.();
  }
  if (stopPropagation) {
    event.stopPropagation();
  }
}, "isolate");

// src/@react/maybeCloneElement/maybeCloneElement.ts
var import_utils7 = require("@appd/utils");
var import_react4 = require("react");

// src/@react/maybeCloneElement/isOnlyChild.ts
var import_react3 = require("react");
var isOnlyChild = /* @__PURE__ */ __name((children) => {
  try {
    import_react3.Children.only(children);
    return true;
  } catch {
    return false;
  }
}, "isOnlyChild");

// src/@react/maybeCloneElement/maybeCloneElement.ts
var maybeCloneElement = /* @__PURE__ */ __name((children, props, ref) => isOnlyChild(children) ? (0, import_react4.cloneElement)(
  children,
  // Supports refs.
  //
  // Otherwise,
  //   Warning: Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to
  //   use React.forwardRef()?
  typeof children.type === "object" && Object.hasOwn(children.type, "$$typeof") && // Doesn't already have a ref attached (since we would overwrite it).
  !(0, import_utils7.maybeGet)(children, "ref") && // Have something to attach.
  ref ? {
    ...props,
    ref
  } : props
) : children, "maybeCloneElement");

// src/@react/measureText.ts
var import_react9 = require("react");

// src/@react/useFontsReady.ts
var import_utils8 = require("@appd/utils");
var import_react8 = require("react");

// src/@react/useLayoutEffect.ts
var import_react5 = __toESM(require("react"));
var useLayoutEffect = CAN_USE_DOM ? import_react5.default.useLayoutEffect : import_react5.useEffect;

// src/@react/useLiveCallback.ts
var import_react7 = require("react");

// src/@react/useLiveRef.ts
var import_react6 = require("react");
var useLiveRef = /* @__PURE__ */ __name((value) => {
  const ref = (0, import_react6.useRef)(value);
  ref.current = value;
  return ref;
}, "useLiveRef");

// src/@react/useLiveCallback.ts
var useLiveCallback = /* @__PURE__ */ __name((...args) => {
  if (args.length === 1) {
    const [callback] = args;
    const ref = useLiveRef(callback);
    return (0, import_react7.useMemo)(
      () => (...args2) => ref.current?.(...args2),
      []
    );
  } else {
    const [callbackFrom, current] = args;
    const ref = useLiveRef(current);
    return (0, import_react7.useMemo)(() => callbackFrom(ref), []);
  }
}, "useLiveCallback");

// src/@react/useFontsReady.ts
var useFontsReady = /* @__PURE__ */ __name((effect = void 0, deps = []) => {
  const [ready, setReady] = (0, import_react8.useReducer)(
    () => true,
    !CAN_USE_DOM || import_utils8.IS_JEST || globalThis.document?.fonts.status === "loaded"
  );
  useLayoutEffect(() => {
    if (!ready) {
      document.fonts.ready.then(setReady);
    }
  }, []);
  const liveEffect = useLiveCallback(typeof effect === "function" ? effect : void 0);
  useLayoutEffect(() => {
    if (ready) {
      liveEffect();
    }
  }, [ready, ...(0, import_utils8.many)(deps)]);
  return ready;
}, "useFontsReady");

// src/IS_JEST.ts
var IS_JEST3 = typeof process !== "undefined" && process.env.JEST_WORKER_ID !== void 0 && // https://stackoverflow.com/questions/50940640/how-to-determine-if-jest-is-running-the-code-or-not#comment114922197_52231746
process.env.NEXT_PHASE === void 0;

// src/lazyConstant.ts
var lazyConstant = /* @__PURE__ */ __name((initialize, value = Symbol.for("UNINITIALIZED"), get = Object.assign(() => value === Symbol.for("UNINITIALIZED") ? value = initialize() : value, initialize)) => get, "lazyConstant");

// src/@react/measureText.ts
var measureText = /* @__PURE__ */ __name((fontOrToken) => {
  let font = "";
  const measurer = measureText.MEASURER();
  return (text) => {
    if (!font) {
      font = fontOrToken.startsWith("var(--") ? getComputedStyle(document.documentElement).getPropertyValue(fontOrToken.slice("var(".length, -")".length)) : fontOrToken;
    }
    measurer.font = font;
    return measurer.measureText(text).width;
  };
}, "measureText");
measureText.MEASURER = lazyConstant(
  () => !IS_JEST3 && globalThis.document?.createElement("canvas").getContext("2d") || {
    font: "",
    // Default value needed for jsdom environments (e.g. Jest).
    measureText: () => ({ width: 0 })
  }
);
measureText.use = ({
  font,
  initialText = "",
  initialWidth = NaN
}) => {
  const isFontsReady = useFontsReady(() => setTextWidth(initialText), []);
  const measure = useLiveCallback(
    (0, import_react9.useMemo)(() => isFontsReady ? measureText(font) : () => initialWidth, [font, initialWidth, isFontsReady])
  );
  const [textWidth, setTextWidth] = (0, import_react9.useReducer)((_, text) => measure(text), initialWidth);
  return {
    measure,
    setTextWidth,
    /** Will remain at `initialWidth` until `useFontsReady()` is `true`. */
    textWidth
  };
};

// src/@react/memo.ts
var import_react10 = __toESM(require("react"));
var memo = import_react10.default.memo;

// src/@react/mutationObserver.ts
var import_utils9 = require("@appd/utils");
var mutationObserver = /* @__PURE__ */ __name((node, callback, options) => {
  if (!node) {
    return import_utils9.noop;
  }
  if (!mutationObserver.CALLBACKS.get(node)?.add(callback)) {
    mutationObserver.CALLBACKS.set(node, /* @__PURE__ */ new Set([callback]));
  }
  mutationObserver.OBSERVER().observe(node, options);
  return () => {
    mutationObserver.CALLBACKS.get(node)?.delete(callback);
  };
}, "mutationObserver");
mutationObserver.CALLBACKS = /* @__PURE__ */ new WeakMap();
mutationObserver.OBSERVER = (0, import_utils9.lazyConstant)(
  () => globalThis.MutationObserver && new globalThis.MutationObserver(
    (mutationRecords) => mutationRecords.forEach((mutationRecord) => {
      const subscribers = mutationObserver.CALLBACKS.get(mutationRecord.target);
      if (subscribers) {
        subscribers.forEach((subscriber) => subscriber?.(mutationRecord));
      }
    })
  ) || {
    observe: import_utils9.noop,
    unobserve: import_utils9.noop
  }
);

// src/@react/noSsr.tsx
var import_react12 = require("react");

// src/@react/useDidMount.ts
var import_react11 = require("react");
var useDidMount = /* @__PURE__ */ __name(() => {
  const [didMount, setDidMount] = (0, import_react11.useState)(false);
  (0, import_react11.useEffect)(() => setDidMount(true), []);
  return didMount;
}, "useDidMount");
useDidMount.layoutEffect = () => {
  const [didMount, setDidMount] = (0, import_react11.useState)(false);
  useLayoutEffect(() => setDidMount(true), []);
  return didMount;
};

// src/@react/noSsr.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var noSsr = /* @__PURE__ */ __name((children) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(noSsr.Fragment, { children }), "noSsr");
noSsr.Fragment = ({ children, ...props }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react12.Fragment, { ...props, children: useDidMount.layoutEffect() && children });

// src/@react/PREFERS_REDUCED_MOTION.ts
var PREFERS_REDUCED_MOTION = Boolean(globalThis.matchMedia?.(`(prefers-reduced-motion: reduce)`).matches);

// src/noop.ts
var noop3 = /* @__PURE__ */ __name(() => {
}, "noop");

// src/@react/requestAnimationFrame.ts
var requestAnimationFrame = /* @__PURE__ */ __name((callback) => {
  if (callback) {
    const id = globalThis.requestAnimationFrame(callback);
    return () => globalThis.cancelAnimationFrame(id);
  } else {
    return noop3;
  }
}, "requestAnimationFrame");

// src/@react/resizeObserver.ts
var import_utils10 = require("@appd/utils");
var resizeObserver = /* @__PURE__ */ __name((element, callback, { box = "border-box", ...options } = {}) => {
  if (!element) {
    return import_utils10.noop;
  }
  if (!resizeObserver.CALLBACKS.get(element)?.add(callback)) {
    resizeObserver.CALLBACKS.set(element, /* @__PURE__ */ new Set([callback]));
  }
  resizeObserver.OBSERVER().observe(element, {
    box,
    ...options
  });
  return () => {
    const callbacks = resizeObserver.CALLBACKS.get(element);
    callbacks?.delete(callback);
    if (!callbacks?.size) {
      resizeObserver.OBSERVER().unobserve(element);
      resizeObserver.CALLBACKS.delete(element);
    }
  };
}, "resizeObserver");
resizeObserver.CALLBACKS = /* @__PURE__ */ new WeakMap();
resizeObserver.OBSERVER = (0, import_utils10.lazyConstant)(
  () => globalThis.ResizeObserver && new globalThis.ResizeObserver(
    (entries) => entries.forEach((entry) => {
      const subscribers = resizeObserver.CALLBACKS.get(entry.target);
      if (subscribers) {
        subscribers.forEach(
          (subscriber) => subscriber?.(
            {
              height: entry.borderBoxSize[0]?.blockSize,
              width: entry.borderBoxSize[0]?.inlineSize
            },
            entry
          )
        );
      }
    })
  ) || {
    observe: import_utils10.noop,
    unobserve: import_utils10.noop
  }
);

// src/@react/useBroadcastRef.ts
var import_react13 = require("react");
var useBroadcastRef = /* @__PURE__ */ __name((...args) => {
  const defaultSource = (0, import_react13.useRef)().current ??= // Initialize only once.
  {
    _current: void 0,
    get current() {
      return this._current;
    },
    // Synchronously forward updates to sinks. Don't wait until `useLayoutEffect` since could be too late.
    set current(value) {
      forwardValues(sinks.current, this._current = value);
    }
  };
  const { sinks, source } = args[0] && "source" in args[0] ? {
    sinks: useLiveRef(args[0].sinks),
    source: args[0].source || defaultSource
  } : {
    sinks: useLiveRef(args),
    source: defaultSource
  };
  useLayoutEffect(() => {
    if (source === defaultSource) {
      return;
    }
    const callbacks = forwardValues(sinks.current, source.current);
    return () => callbacks.forEach((callback) => callback(null));
  }, [source.current]);
  return source;
}, "useBroadcastRef");
var forwardValues = /* @__PURE__ */ __name((sinks, value) => {
  const callbacks = sinks.filter((sink) => typeof sink === "function");
  const objects = sinks.filter((sink) => typeof sink !== "function" && Boolean(sink));
  callbacks.forEach((callback) => callback(value));
  objects.forEach((object) => object.current = value);
  return callbacks;
}, "forwardValues");

// src/@react/useControlledState.ts
var import_react15 = require("react");

// src/@react/useEffect.ts
var import_utils11 = require("@appd/utils");
var import_react14 = __toESM(require("react"));
var useEffect3 = /* @__PURE__ */ __name((effect, deps) => import_react14.default.useEffect(() => {
  const destructors = effect();
  return () => (0, import_utils11.many)(destructors).forEach((f) => f && f());
}, deps), "useEffect");
useEffect3.unstrict = (effect, deps) => useEffect3((destructors) => {
  Promise.resolve().then(() => destructors ??= /* Maybe skipped by `destructors = []` below. */
  (0, import_utils11.many)(effect()));
  return () => {
    (0, import_utils11.many)(destructors).forEach((f) => f && f());
    destructors = [];
  };
}, deps);

// src/@react/useControlledState.ts
var useControlledState = /* @__PURE__ */ __name((initialValue, prop, onChange, onSync) => {
  const [state, setState] = (0, import_react15.useState)(initialValue);
  const lastEmitted = (0, import_react15.useRef)(state);
  const [changes, setChanges] = (0, import_react15.useState)([]);
  const [syncs, setSyncs] = (0, import_react15.useState)([]);
  const isControlled = Object.assign((0, import_react15.useRef)(false), { current: prop !== void 0 });
  if (prop !== void 0 && prop !== state) {
    setState(prop);
    setSyncs([...syncs, [state, prop]]);
    lastEmitted.current = prop;
  }
  useEffect3.unstrict(() => {
    if (changes.length) {
      onChange && changes.forEach((change) => onChange(...change));
      lastEmitted.current = changes.at(-1)?.[0] ?? state;
      setChanges([]);
    }
  }, [changes, onChange, state]);
  useEffect3.unstrict(() => {
    if (syncs.length) {
      onSync && syncs.forEach((sync) => onSync(...sync));
      setSyncs([]);
    }
  }, [syncs, onSync]);
  return [
    state,
    (0, import_react15.useCallback)(
      (rawNext, ...args) => isControlled.current ? (
        // In controlled mode, accumulate change events, but don't actually update local state.
        setChanges((changes2) => {
          const old = changes2.at(-1)?.[0] ?? lastEmitted.current;
          const next = rawNext instanceof Function ? rawNext(old) : rawNext;
          return old === next ? changes2 : [...changes2, [next, ...args]];
        })
      ) : (
        // Accumulate change events and update local state.
        setState((old) => {
          const next = rawNext instanceof Function ? rawNext(old) : rawNext;
          old !== next && setChanges((changes2) => [...changes2, [next, ...args]]);
          return next;
        })
      ),
      []
    )
  ];
}, "useControlledState");

// src/@react/useOnlyChildWithRef.ts
var import_utils12 = require("@appd/utils");
var import_react16 = require("react");
var useOnlyChildWithRef = /* @__PURE__ */ __name((children, forwardedRef) => {
  const child = (0, import_react16.useMemo)(() => {
    try {
      import_react16.Children.only(children);
      if (!children || !(0, import_react16.isValidElement)(children)) {
        throw Error("Implementation Error: Somehow `Children.only()` didn't throw.");
      }
    } catch (error) {
      import_utils12.IS_DEV_MODE && console.warn(error);
      return (0, import_react16.createElement)(import_react16.Fragment, void 0, children);
    }
    if (!{ INTRINSIC: typeof children.type === "string" }.INTRINSIC && !{ EXOTIC: typeof children.type === "object" && "$$typeof" in children.type }.EXOTIC) {
      import_utils12.IS_DEV_MODE && console.warn("`children` doesn't support refs. Expected `children` to be an intrinsic or exotic element.");
    }
    return children;
  }, [children]);
  if (typeof child.ref === "string") {
    throw Error("LegacyRef not supported.");
  }
  const ref = useBroadcastRef(forwardedRef, child.ref);
  return {
    ref,
    withRef: (0, import_react16.cloneElement)(child, { ref })
  };
}, "useOnlyChildWithRef");

// src/@react/wrap.tsx
var import_utils13 = require("@appd/utils");
var import_jsx_runtime2 = require("react/jsx-runtime");
var wrap = /* @__PURE__ */ __name((Inner) => ({
  with: (getOuter) => (
    // @ts-expect-error
    // Type '(props: Extend<P, Q>, ref: R[0]) => Element' is not assignable to type '(props: Extend<P, Q>, ...[ref]: R) => T'.
    Inner.length > 1 || (0, import_utils13.maybeGet)(Inner, "$$typeof") ? (
      // React cares about the function's `.length`, so must manually distinguish.
      forwardRef((props, ref) => {
        const Outer = getOuter();
        return (
          // @ts-expect-error
          // Type 'Extend<P, Q> & { children: Element; }' is not assignable to type 'IntrinsicAttributes & Q'.
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Outer, { ref, ...props, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Inner, { children: props.children }) })
        );
      })
    ) : (props) => {
      const Outer = getOuter();
      return (
        // @ts-expect-error
        // Type 'Extend<P, Q> & { children: Element; }' is not assignable to type 'IntrinsicAttributes & Q'.
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Outer, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Inner, { children: props.children }) })
      );
    }
  )
}), "wrap");
//# sourceMappingURL=utils.@react.js.map
